module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-photo-6-7a3f4782f1ee1fc55cb4af1c17f65b78.webp";